module.exports = __webpack_public_path__ + "static/img/teachersimg.977ee9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teachersimg.png
// module id = Uphm
// module chunks = 20